module.exports = __webpack_public_path__ + "static/assets/18a6f5c4865e6af60206964b724ad3bd.png";